import type { BaseResponse, Event } from "@anggunpraya-templates/types";
import { useInvitationPage as useBaseInvitationPage } from "@anggunpraya-templates/base/app/composables/use-invitation-page";
import { EVENT_DETAIL } from "~/data";

export async function useInvitationPage() {
  const { loadEventGuest } = useEventGuestLoader();

  return await useBaseInvitationPage({
    previewEventDetail: EVENT_DETAIL as BaseResponse<Event>,
    loadEventGuest,
  });
}
